import { Injectable } from '@angular/core';
import { PersonClient } from '@models/clients';
import { SalutationOptionType } from '@models/matter';

@Injectable({
	providedIn: 'root',
})
export class SalutationsService {
	getPersonPrimarySalutation(client: PersonClient) {
		switch (client.primarySalutationOption) {
			case SalutationOptionType.FORMAL:
				return this.getPersonFormalSalutation(client);
			case SalutationOptionType.INFORMAL:
				return this.getPersonInformalPrimarySalutation(client);
			default:
				return client.customPrimarySalutation;
		}
	}

	getPersonEnvelopeSalutation(client: PersonClient) {
		switch (client.envelopeSalutationOption) {
			case SalutationOptionType.FORMAL:
				return this.getPersonFormalSalutation(client);
			case SalutationOptionType.INFORMAL:
				return this.getPersonInformalEnvelopeSalutation(client);
			default:
				return client.customEnvelopeSalutation;
		}
	}

	getPersonFormalSalutation(client: PersonClient) {
		return [client.title, client.firstName, client.middleNames, client.lastName]
			.filter((x) => x)
			.join(' ');
	}

	getPersonInformalPrimarySalutation(client: PersonClient) {
		return client.firstName;
	}

	getPersonInformalEnvelopeSalutation(client: PersonClient) {
		return `${client.firstName} ${client.lastName}`;
	}
}
